
define('text!modules/T1App/labs/templates/apps.html',[],function () { return '<div class="t1-apps-container"></div>\n';});

